module.exports = __webpack_public_path__ + "static/media/hdi-checkmark.16a271cd.svg";